import { render, staticRenderFns } from "./extra-vorbereitungsprogramm.vue?vue&type=template&id=e604b436&scoped=true&lang=pug&"
import script from "./extra-vorbereitungsprogramm.vue?vue&type=script&lang=js&"
export * from "./extra-vorbereitungsprogramm.vue?vue&type=script&lang=js&"
import style0 from "./extra-vorbereitungsprogramm.vue?vue&type=style&index=0&id=e604b436&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e604b436",
  null
  
)

export default component.exports